import * as types from './action-types'

function handleErrors(res) {
  if (!res.ok) throw Error(res.statusText)
  return res
}

export const clearCollectionRows = () => ({
  type: types.CLEAR_COLLECTION_ROWS
})

const requestCollectionRows = id => ({
  type: types.REQUEST_COLLECTION_ROWS,
  payload: id
})

const receiveCollectionRows = data => ({
  type: types.RECEIVE_COLLECTION_ROWS,
  payload: {
    data,
    receivedAt: Date.now()
  }
})

const errorCollectionRows = () => ({
  type: types.ERROR_COLLECTION_ROWS
})

export const fetchCollectionRows = id => dispatch => {
  dispatch(requestCollectionRows(id));

  return fetch(`/api/collections/${id}`)
    .then(handleErrors)
    .then(res => res.json())
    .then(json => dispatch(receiveCollectionRows(json)))
    .catch(e => dispatch(errorCollectionRows(e)))
}



// WEBPACK FOOTER //
// ./src/components/collection-container/actions.js